import { Skeleton } from "antd5";

import Modal from "components/ui/modal/Modal";
import toast from "components/ui/toast/Toast";
import { AlertForm } from "components/views/AlertForm";
import { FormValues } from "components/views/SavedViewForm";
import { useSavedViewAlert } from "lib/hooks/api/lead_subscriptions/useSavedViewAlert";
import { useEditSavedViewAlerts } from "lib/hooks/api/notices/views/useEditSavedViewAlerts";
import { LeadSubscriptionFrequency } from "lib/types/graphQLEnums";
import { ModalView } from "./utils";

type EditAlertsModalProps = {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  selectedView: ModalView;
};

export function EditAlertsModal({ isOpen, onOpenChange, selectedView }: EditAlertsModalProps) {
  const { alert: personalSavedViewAlert, isLoading: isLoadingSubscriptionContents } =
    useSavedViewAlert(selectedView.id);

  const { mutate: editAlertsMutation, isLoading } = useEditSavedViewAlerts({
    onSuccess: async (_data, _vars) => {
      onOpenChange(false);
      toast.success("Alerts saved");
    },
    onError: async () => {
      toast.error("Failed to save alerts");
    },
  });

  return (
    <Modal open={isOpen} onOpenChange={onOpenChange} padding={24}>
      {isLoadingSubscriptionContents ? (
        <Skeleton style={{ width: 270, height: 110 }} paragraph={{ rows: 1 }} />
      ) : (
        <AlertForm
          defaultValues={{
            viewName: selectedView.name,
            viewDescription: selectedView.description ?? "",
            alertFrequency: personalSavedViewAlert?.id ? personalSavedViewAlert.frequency : "NEVER",
          }}
          isStandardView={selectedView.isStandardView}
          onSubmit={(data: FormValues) =>
            editAlertsMutation({
              request: {
                id: selectedView.id,
                name: selectedView.name,
                alertId: personalSavedViewAlert?.id,
                alertFrequency:
                  data.alertFrequency === "NEVER"
                    ? undefined
                    : (data.alertFrequency as LeadSubscriptionFrequency),
              },
            })
          }
          onCancel={() => onOpenChange(false)}
          isLoading={isLoading}
        />
      )}
    </Modal>
  );
}
